import React from "react";
import { useLocation } from "react-router-dom";
import useScrollToTop from "./../../../hooks/useScollToTop";
import "./AttestationPage.css";
import { toAbsolutePhotoUrl } from "../../../services/settingsPhotoServices";

const AttestationPage = () => {
  useScrollToTop();
  const location = useLocation();
  const {
    prenom,
    nom,
    dateNaissance,
    adresse,
    cp,
    commune,
    cotisation,
    licence,
    reductionFoyer,
    passSport,
    reductionSaison,
    typeReglement,
    nbReglement,
    statutReglement,
    observations,
    datePaiement,
    president,
    association,
    logo,
    adresse_club,
    tel_club,
    mail_club,
    siteweb_club,
    siret_club,
    saison_active,
  } = location.state || {};

  if (!location.state) {
    return <div>Pas de données disponibles pour cette attestation.</div>;
  }

  const handlePrint = () => {
    window.print();
  };

  const totalMontant =
    parseFloat(cotisation) +
    parseFloat(licence) +
    (parseFloat(reductionFoyer) +
      parseFloat(passSport) +
      parseFloat(reductionSaison));

  const FALLBACK_LOGO = "/img/no-image.jpg";
  const logoSrc = toAbsolutePhotoUrl(logo?.trim() || "") || FALLBACK_LOGO;

  return (
    <div className="container_print mx-auto py-[150px] px-4 font-satoshi bg-white text-black">
      <div className="printable-area mx-auto max-w-4xl p-8 shadow-lg border border-gray-300 rounded-xl bg-white">
        {/* En-tête */}
        <div className="flex justify-between items-center mb-6 border-b pb-4">
          <div>
            <h1 className="text-2xl font-bold uppercase tracking-wide text-gray-800 mt-4">
              {association}
            </h1>
            <p className="text-sm text-gray-600">{adresse_club}</p>
            <p className="text-sm text-gray-600">Tél : {tel_club}</p>
            <p className="text-sm text-gray-600">Email : {mail_club}</p>
            <p className="text-sm text-gray-600">Site : {siteweb_club}</p>
            <p className="text-sm text-gray-600">SIRET : {siret_club}</p>
          </div>

          <img
            src={logoSrc}
            alt="Logo club"
            className="w-28 h-28 object-contain"
          />
        </div>

        {/* Titre */}
        <h2 className="text-center text-xl font-bold underline mb-6">
          ATTESTATION D’INSCRIPTION – SAISON {saison_active}
        </h2>

        {/* Corps */}
        <p className="mb-4 leading-relaxed text-justify">
          Je soussigné <strong>{president}</strong>, Président de l’association{" "}
          <strong>{association}</strong>, certifie que :
        </p>

        <div className="mb-4 space-y-1">
          <p>
            Prénom : <strong>{prenom}</strong>
          </p>
          <p>
            NOM : <strong>{nom}</strong>
          </p>
          <p>
            Né(e) le : <strong>{dateNaissance}</strong>
          </p>
          <p>
            Adresse :{" "}
            <strong>
              {adresse}, {cp} {commune}
            </strong>
          </p>
        </div>

        <p className="mb-6">
          est inscrit(e) au sein de notre association pour la saison{" "}
          <strong>{saison_active}</strong>.
        </p>

        {/* Tableau de cotisation */}
        <div className="border rounded-md p-4 bg-gray-50 mb-6">
          <h3 className="font-semibold mb-3 underline">
            Détails du Règlement :
          </h3>
          <ul className="space-y-1">
            <li>
              Licence/assurance : <strong>{licence} €</strong>
            </li>
            <li>
              Cotisation : <strong>{cotisation} €</strong>
            </li>
            {parseFloat(reductionFoyer) !== 0 && (
              <li>
                Réduction Foyer : <strong>{reductionFoyer} €</strong>
              </li>
            )}
            {parseFloat(passSport) !== 0 && (
              <li>
                {" "}
                Pass Sport : <strong>{passSport} €</strong>
              </li>
            )}
            {parseFloat(reductionSaison) !== 0 && (
              <li>
                Réduction Saison : <strong>{reductionSaison} €</strong>
              </li>
            )}
          </ul>
          <hr className="my-3" />
          <p className="text-lg font-bold">
            💰 Total à payer : {totalMontant.toFixed(2)} €
          </p>
          {typeReglement && (
            <p>
              💳 Type de règlement : <strong>{typeReglement}</strong>
            </p>
          )}
          {nbReglement !== 0 && (
            <p>
              📄 Nombre de règlements : <strong>{nbReglement}</strong>
            </p>
          )}
          {statutReglement && (
            <p>
              📌 Statut : <strong>{statutReglement}</strong>
            </p>
          )}
          {observations && (
            <p>
              📝 Observations : <strong>{observations}</strong>
            </p>
          )}
        </div>

        <div className="text-right mt-8">
          <p className="mb-1">
            Fait le : <strong>{datePaiement}</strong>
          </p>
          <p className="mt-2">Le/la Président(e),</p>
          <p className="font-semibold">{president}</p>
        </div>
      </div>

      {/* Bouton Imprimer */}
      <div className="text-center mt-6">
        <button
          onClick={handlePrint}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Imprimer / Générer PDF
        </button>
      </div>
    </div>
  );
};

export default AttestationPage;
